module.exports = __webpack_public_path__ + "182489793c1af9e3b56937b06e453dc3.MP3";